export const getFullNameWithNullGuards = (firstName: string | null, lastName: string | null) => {
  const firstNameString = firstName || '';
  const lastNameString = lastName || '';
  return `${firstNameString}${firstName && lastName ? ' ' : ''}${lastNameString}`;
};

export default getFullNameWithNullGuards;
